import { render } from "./EnterForgotPasswordVerificationCodePage.vue?vue&type=template&id=71eb86e2&scoped=true"
import script from "./EnterForgotPasswordVerificationCodePage.vue?vue&type=script&lang=js"
export * from "./EnterForgotPasswordVerificationCodePage.vue?vue&type=script&lang=js"

import "./EnterForgotPasswordVerificationCodePage.vue?vue&type=style&index=0&id=71eb86e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71eb86e2"]])

export default __exports__